/**
 * Trigger a browser download for an in-memory Blob (e.g. an API `responseType:
 * 'blob'` payload). Shared by the inventory CSV export + CSV-import
 * template/error downloads so the object-URL lifecycle lives in one place.
 */
export const downloadBlob = (blob, filename = 'download') => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
